import { createBlacklistAddress } from './createBlacklistAddress';
import { deleteBlacklistAddress } from './deleteBlacklistAddress';
import { fetchBlacklistAddresses } from './fetchBlacklistAddresses';
import { updateBlacklistAddress } from './updateBlacklistAddress';

export const blacklistAddressService = {
  createBlacklistAddress,
  deleteBlacklistAddress,
  fetchBlacklistAddresses,
  updateBlacklistAddress,
};
